import { Application } from '@/store/applications/types'
import { Lesson, Student } from '@/store/lessons/types'

export const InquiryTypes = {
  classRecord: 'Class Record',
  frs: 'Final Review Sheet',
}
export type inquiryType = keyof typeof InquiryTypes

export interface EvaluationInquiryApplicationsState {
  applications: EvaluationInquiryApplication[];
}

/**
 * 評価問い合わせ申請登録IF
 */
export interface EvaluationInquiryApplication extends Application {
  inquiryType: inquiryType
  lesson: Lesson
  student: Student
  comment: string|null
}

/**
 * 評価問い合わせ申請後の再評価承認IF
 */
export interface EvaluationInquiryForAccept {
  lessonId: string
  studentId: string
}
